import SearchField from '../../../components/SearchField'
import Button from '../../../components/Button'
import { Link } from 'react-router-dom'
import {
    controlList,
    filterForm,
    reqWarehouse,
    reqStowageOrigin,
    storagePage
} from '../storage'
import Dropdown from '../../../components/Dropdown'
import { IterateOptions } from '../../../components/FormUtilities'
import useStorage from '../../../hooks/useStorage'
import FiltersForm from './FiltersForm'
import { Option as OptionType } from '../../../config/types/component'
import Rules from '../../../components/Rules'
import { formTraspase } from '../../Traspase/storage'
import { render, useRender } from 'redity'
import {
    FlexBox,
    FlexLeft,
    FlexRight,
    SectionFiltersGrid
} from '../../../components/UtilsResponsive/UtilsResponsive.style'
import { setCompanySelected } from '../../../utilities/controlStorage'

function Company() {
    const { props } = controlList.useFilter('company_id')
    const { companiesFromSession } = useStorage()

    function handleChange(option: OptionType) {
        filterForm.init()
        controlList.filter.deleteFilter('warehouse_id')
        controlList.filter.deleteFilter('stowage_origin_id')
        reqWarehouse.setQuery('company_id', option.value)
        reqStowageOrigin.setQuery('company_id', option.value)
        reqWarehouse.load()
        reqStowageOrigin.load()

        const company = companiesFromSession.find(
            _company => _company.id === parseInt(option.value)
        )
        if (company.is_enabled) {
            formTraspase.setValue('company', option)
            storagePage.company_enabled = true
        } else {
            formTraspase.setValue('company', null)
            storagePage.company_enabled = false
        }
        setCompanySelected(company)
        storagePage.timezone = company.timezone
        controlList.renderForm()
        props.onChange(option)
        render('button_new')
    }

    return (
        <Dropdown
            {...props}
            onChange={handleChange}
            label="Compañía"
            showLabel={false}
            clear={false}
        >
            <IterateOptions
                data={companiesFromSession.map(company => ({
                    name: company.name,
                    image_url: company.country.image_url,
                    id: company.id,
                    disabled: !company.is_enabled
                }))}
                label="name"
                image="image_url"
                strikeOut="disabled"
            />
        </Dropdown>
    )
}
function Search() {
    const { props } = controlList.useSearch()

    return (
        <SearchField
            {...props}
            placeholder="Buscar por código de traspaso"
            size="auto"
            fullWidth={true}
            className="ml-0"
        />
    )
}

function ButtonNew() {
    useRender('button_new')
    return (
        <Link
            to="/movements/traspases/creation"
            className={
                !storagePage.company_enabled ? 'pointer-events-none' : ''
            }
        >
            <Button
                size="sm"
                className="ml-2"
                disabled={!storagePage.company_enabled}
            >
                Nuevo
            </Button>
        </Link>
    )
}

export default function Filters() {
    return (
        <SectionFiltersGrid>
            <Search />
            <FlexBox>
                <FlexLeft>
                    <Company />
                    <FiltersForm />
                </FlexLeft>
                <FlexRight>
                    <Rules cu={'CU317'}>
                        <ButtonNew />
                    </Rules>
                </FlexRight>
            </FlexBox>
        </SectionFiltersGrid>
    )
}
